import { ReactNode } from "react";
export interface IDropdownItem {
  children: ReactNode;
  className?: string;
}

function DropdownItem({ children }: IDropdownItem) {
  return <li className="dropdown-item">{children}</li>;
}
export default DropdownItem;
